// VRG-741 — GTM → Articles → Rules: the editorial rules, READ-ONLY, from the checked-in snapshot
// `@repo/types` EDITORIAL_RULES (regenerate with apps/platform/scripts/generate-editorial-rules.mjs).
// The canon is the brain repo's messaging/editorial-style.md at the commit printed below. The
// future write-draft step (apps/api content-ideas.write.seam.ts) reads the SAME snapshot, so the
// rules Spencer reads here and the rules the writer obeys cannot drift. Editing rules in-app is a
// later decision; edit them in the brain repo, then regenerate.
import React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { Box, Stack, useTheme } from '@mui/material'
import { EDITORIAL_RULES } from '@repo/types'
import { Alert, Card } from '@repo/ui'

const P = EDITORIAL_RULES.provenance

const useMarkdownSx = () => {
  const theme = useTheme()
  return {
    '& h1': { ...theme.typography.h5, mt: 0, mb: 3 },
    '& h2': { ...theme.typography.h6, mt: 6, mb: 2 },
    '& h3': { ...theme.typography.body1, fontWeight: 600, mt: 4, mb: 1.5 },
    '& > :first-child': { mt: 0 },
    '& p, & li': { ...theme.typography.body2, lineHeight: 1.6 },
    '& ul, & ol': { pl: 5, my: 2 },
    '& table': { borderCollapse: 'collapse', my: 3, width: '100%', display: 'block', overflowX: 'auto' },
    '& th, & td': {
      border: `1px solid ${theme.palette.primary[100]}`,
      padding: '8px 12px',
      textAlign: 'left',
      verticalAlign: 'top',
      ...theme.typography.body3,
    },
    '& th': { fontWeight: 600 },
    '& code': { fontSize: 12 },
    '& hr': { border: 0, borderTop: `1px solid ${theme.palette.divider}`, my: 5 },
  }
}

export const EditorialRulesPanel = () => {
  const sx = useMarkdownSx()
  return (
    <Stack spacing={4}>
      <Alert
        severity="info"
        description={`Read-only copy of ${P.repo}/${P.path} at ${P.source}, file last changed in ${P.fileCommit} on ${P.fileDate} (sha256 ${P.sha256.slice(0, 12)}…). Edit it in the brain repo, then regenerate this copy.`}
      />
      <Card>
        <Box sx={sx}>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{EDITORIAL_RULES.markdown}</ReactMarkdown>
        </Box>
      </Card>
    </Stack>
  )
}
